import {ValidatorFn, Validators} from "@angular/forms";
import {PasswordStrength} from "./services/a-b.service";

// Cognito rejects a password that starts or ends with whitespace (^[\S]+.*[\S]+$), whatever the
// password-rule arm, so both arms check it before signup gets that far.
const noEdgeWhitespaceValidator: ValidatorFn = (control) =>
  /^\s|\s$/.test(control.value ?? '') ? {edgeWhitespace: true} : null;

const withNoEdgeWhitespace = (ruleValidator: ValidatorFn): ValidatorFn =>
  (control) => noEdgeWhitespaceValidator(control) ?? ruleValidator(control);

const strictPasswordValidator = withNoEdgeWhitespace(
  Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/)
);
const relaxedPasswordValidator = withNoEdgeWhitespace(Validators.minLength(6));

const strictPasswordValidationErrorMessage = 'Your password needs to be at least 8 characters including a lower-case letter, an upper-case letter, a number and one special character (!@#$%^&*)';
const relaxedPasswordValidationErrorMessage = 'Your password needs to be at least 6 characters';

// Validators.email accepts a domain with no dot (name@gmail), which Stripe rejects once the user
// tries to start a trial. The pattern only adds the dot; Validators.email checks the rest.
export const emailValidators = [Validators.email, Validators.pattern(/@[^@]*\.[^@.]+$/)];

export const emailValidationErrorMessage = {
  email: 'Please enter a valid email address',
  pattern: 'Please check the part after the @, e.g. name@gmail.com',
};

const passwordEdgeWhitespaceErrorMessage = "Your password can't start or end with a space";

export function getPasswordValidator(strength: PasswordStrength) {
  return strength === 'relaxed' ? relaxedPasswordValidator : strictPasswordValidator;
}

export function getPasswordValidationErrorMessage(strength: PasswordStrength): Record<string, string> {
  const ruleMessage = strength === 'relaxed' ? relaxedPasswordValidationErrorMessage : strictPasswordValidationErrorMessage;
  return {
    edgeWhitespace: passwordEdgeWhitespaceErrorMessage,
    required: ruleMessage,
    pattern: ruleMessage,
    minlength: ruleMessage,
  };
}
